import { styled } from 'styled-components';

import { VisuallyHidden } from '../../styles/shared';

export const HiddenLegend = styled.legend`
    ${VisuallyHidden}
`;
